import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import parkImg from "../assets/images/park1.jpg";
import kidsBracelets from "../assets/shared-images/kids-colors-showcase.png";

const Invest = () => {
  const { t } = useTranslation("invest");

  return (
    <>
      <div className="min-h-screen w-full">
        <div className="flex justify-center w-full h-full">
          <div className="flex justify-center items-center w-full max-w-screen-xl py-16 mb-12 px-6">
            <div className="flex flex-col md:flex-row h-full justify-center gap-5">
              {/* Text */}
              <div className="flex flex-col h-full md:w-1/2 justify-center mr-3">
                <h1>{t("title")}</h1>
                <p className="text-lg">{t("content")}</p>
                <br />
                <h2>{t("why_invest.title")}</h2>
                <ul className="list-disc pl-5">
                  {t("why_invest.items", { returnObjects: true }).map(
                    (item, index) => (
                      <li key={index} className="mb-2">
                        <p>{item.title}</p>
                      </li>
                    )
                  )}
                </ul>
                <br />
                <p className="text-purple text-xl">
                  <Trans
                    i18nKey="cta"
                    components={{
                      a: <a href="mailto:nadia@tuutuum.se" />,
                    }}
                  >
                    {t("cta")}
                  </Trans>
                </p>
              </div>
              {/* Image */}
              <div className="flex flex-col h-full items-end justify-center md:w-1/2">
                <img
                  src={kidsBracelets}
                  alt="Tuutuum medical ID bracelets in metal"
                  className="shadow-sm"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Invest;
